const setUser = (state, data) => {
    state.user = data;
}

export default {
    setUser,
}
